module.exports = __webpack_public_path__ + "img/hip-mesomorph-male.e0de40b8.svg";